export default "__VITE_ASSET__ea939a04__"